<template>
  <div class="edit-bill-box">
    <el-dialog
      title="商人上分"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="200px" :rules="rules">
        <el-form-item label="商户id:" prop="traderId">
          <el-input size="small" placeholder="请输入商户id" v-model="params.traderId" disabled></el-input>
        </el-form-item>

        <el-form-item label="商人余额:" prop="balance">
          <el-input size="small" placeholder="请输入要增加的金额" v-model="params.balance"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      // 状态列表
      params: {
        uid: "",
        traderId: undefined,
        balance: undefined,
      },
      rules: {
        traderId: [{ required: true, message: "必填", trigger: "blur" }],
        balance: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        traderId: undefined,
      };
      this.$refs["form"].resetFields();
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.handleaddOrDebitScoren();
        } else {
          return false;
        }
      });
    },
    handleaddOrDebitScoren() {
      API.addOrDebitScore({
        traderId: this.params.traderId,
        balance: parseFloat(this.params.balance),
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "商人上分成功",
              type: "success",
            });
            this.$emit("handlerBillList");
          } else {
            this.$message.error("商人上分失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    open(row) {
      this.dialogVisible = true;
      this.params = { ...row, ...{} };
      this.params.traderId = this.params.uid;
      this.params.balance = "";
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>
